
<template>
	<div>
		
		<el-card>
			<el-table :data="data.feedbacks"  style="width: 100%;text-align: center;" size="mini">
				<el-table-column align="center" header-align="center" label="编号" width="100">
					<template slot-scope="scope">
						{{scope.$index + 1}}
					</template>
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="store_name" label="门店名称">
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="feedback_title" label="标题">
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="feedback_content" label="内容">
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="" label="日期">
					<template slot-scope="scope">
						{{timeFormat(scope.row.feedback_date,'yyyy-mm-dd hh:MM:ss')}}
						<!-- <el-button size="mini" type="danger" @click="deleteStore(scope.$index, scope.row)">取消认证</el-button> -->
					</template>
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="" label="图片">
					<template slot-scope="scope">
						<el-popover
						  placement="right"
						  width="400" 
						  trigger="click">
						   <el-image v-for="url in toArray(scope.row.feedback_img)" :key="url" :src="host+url" lazy></el-image>
						  <el-button type="primary" size="mini" slot="reference">查看</el-button>
						</el-popover>
					</template>
				</el-table-column>
			</el-table>
			<div style="display: flex;justify-content: flex-end; ">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="formInline.page"
				 :page-sizes="[10, 20, 50, 100]" :page-size="formInline.limit" layout="total, sizes, prev, pager, next, jumper"
				 :total="data.feedbacksTotal">
				</el-pagination>
			</div>
		</el-card>
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				formInline: {
					page: 1,
					limit: 20,
				},
				data: []
			}
		},
		mounted() {
			this.getData();
		},
		methods: {
			toArray(str){
				var arry=str.split(",");
				console.log(arry);
				return arry;
			},
			handleSizeChange(e) {
				this.formInline.limit = e;
				this.getData();
			},
			handleCurrentChange(e) {
				this.formInline.page = e;
				this.getData();
			},
			getData() {
				var that = this;
				this.$axios.post('zuche/feedback/getFeebackList', this.formInline).then(function(res) {
					console.log(res);
					if (res.data.success) {
						that.data = res.data.result;
					} else {
						that.$message.error(res.data.message);
					}
				});
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/fankuijianyi.vue